export const SCROLLING_REFERENCE = 'SCROLLING_REFERENCE';
export const FETCH_WEATHER_REQUEST = 'FETCH_WEATHER_REQUEST';
export const FETCH_WEATHER_SUCCESS = 'FETCH_WEATHER_SUCCESS';
export const FETCH_WEATHER_FAILURE = 'FETCH_WEATHER_FAILURE';
export const SAVING_PATHNAME = 'SAVING_PATHNAME';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const SIGNOUT = 'SIGNOUT';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const FETCH_GALLERY_SUCCESS = 'FETCH_GALLERY_SUCCESS';
export const FETCH_GALLERY_REQUEST = 'FETCH_GALLERY_REQUEST';
export const FETCH_GALLERY_FAILURE = 'FETCH_GALLERY_FAILURE';

export const FETCH_GALLERIES_SUCCESS = 'FETCH_GALLERIES_SUCCESS';
export const FETCH_GALLERIES_REQUEST = 'FETCH_GALLERIES_REQUEST';
export const FETCH_GALLERIES_FAILURE = 'FETCH_GALLERIES_FAILURE';

export const CHOOSE_GROUP_SLUG = 'CHOOSE_GROUP_SLUG';

export const FETCH_SAVE_DEVICE_SUCCESS = 'FETCH_SAVE_DEVICE_SUCCESS';
export const FETCH_SAVE_DEVICE_REQUEST = 'FETCH_SAVE_DEVICE_REQUEST';
export const FETCH_SAVE_DEVICE_FAILURE = 'FETCH_SAVE_DEVICE_FAILURE';

export const FETCH_MENUS_SUCCESS = 'FETCH_MENUS_SUCCESS';
export const FETCH_MENUS_REQUEST = 'FETCH_MENUS_REQUEST';
export const FETCH_MENUS_FAILURE = 'FETCH_MENUS_FAILURE';

export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';

export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';

export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = 'SUBSCRIBE_FAILURE';

export const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'UNSUBSCRIBE_FAILURE';

export const FETCH_EVENTS_SLUG_REQUEST = 'FETCH_EVENTS_SLUG_REQUEST';
export const FETCH_EVENTS_SLUG_SUCCESS = 'FETCH_EVENTS_SLUG_SUCCESS';
export const FETCH_EVENTS_SLUG_FAILURE = 'FETCH_EVENTS_SLUG_FAILURE';

export const FETCH_DAIRIES_REQUEST = 'FETCH_DAIRIES_REQUEST';
export const FETCH_DAIRIES_SUCCESS = 'FETCH_DAIRIES_SUCCESS';
export const FETCH_DAIRIES_FAILURE = 'FETCH_DAIRIES_FAILURE';

export const FETCH_DAIRIES2_REQUEST = 'FETCH_DAIRIES2_REQUEST';
export const FETCH_DAIRIES2_SUCCESS = 'FETCH_DAIRIES2_SUCCESS';
export const FETCH_DAIRIES2_FAILURE = 'FETCH_DAIRIES2_FAILURE';

export const SEND_CONTACT_REQUEST = 'SEND_CONTACT_REQUEST';
export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS';
export const SEND_CONTACT_FAILURE = 'SEND_CONTACT_FAILURE';

export const NEW_BOOKING_REQUEST = 'NEW_BOOKING_REQUEST';
export const NEW_BOOKING_SUCCESS = 'NEW_BOOKING_SUCCESS';
export const NEW_BOOKING_FAILURE = 'NEW_BOOKING_FAILURE';

export const FETCH_VIDEO_SLUG_SUCCESS = 'FETCH_VIDEO_SLUG_SUCCESS';
export const FETCH_VIDEO_SLUG_REQUEST = 'FETCH_VIDEO_SLUG_REQUEST';
export const FETCH_VIDEO_SLUG_FAILURE = 'FETCH_VIDEO_SLUG_FAILURE';

export const FETCH_VIDEOS_REQUEST = 'FETCH_VIDEOS_REQUEST';
export const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS';
export const FETCH_VIDEOS_FAILURE = 'FETCH_VIDEOS_FAILURE';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js